$(function () {
  handleProductQuantity();
  handleMobilePreStepPanel();
  handleOneClickCheckout();
  handleProductSlideshow();
  handleProductIntroVideoSize();

  const productId = Citiesocial.productManager.getProductId();
  if (productId) {
    Citiesocial.productViewHistory.addProductView(productId);
  }

  function handleProductQuantity() {
    const $productQuantityInput = $(
      '.product__quantity input[name="quantity"]',
    );
    const $minusButton = $('.quantity__minus');
    const $plusButton = $('.quantity__plus');
    checkMinusButtonAndQuantity();

    $productQuantityInput.change(function () {
      checkMinusButtonAndQuantity();
    });
    $minusButton.click(function () {
      $productQuantityInput.val(function (i, oldValue) {
        return Number(oldValue) - 1;
      });
      checkMinusButtonAndQuantity();
    });
    $plusButton.click(function () {
      $productQuantityInput.val(function (i, oldValue) {
        return Number(oldValue) + 1;
      });
      checkMinusButtonAndQuantity();
    });

    function checkMinusButtonAndQuantity() {
      const quantity = Number($productQuantityInput.val());
      if (quantity < 1) {
        $minusButton.attr('disabled', 'disabled');
        $productQuantityInput.val(1);
        alert('購買數量至少為1!');
      }
      if (quantity <= 1) {
        $minusButton.attr('disabled', 'disabled');
      } else {
        $minusButton.removeAttr('disabled');
      }
    }
  }

  function handleMobilePreStepPanel() {
    const $form = $('.product__form');
    const $preAddToCartBtn = $('.product__pre-add-to-cart');
    const $preOneClickCheckoutBtn = $('.product__pre-one-click-checkout');
    const $addToCartBtn = $('.product__add-to-cart');
    const $oneClickCheckoutBtn = $('.product__one-click-checkout');
    const $modalBackDrop = $('.modal-backdrop');
    const $modalBtn = $('.modal__btn');
    const productFormShowClass = 'product__form--show';

    $preAddToCartBtn.click(function () {
      $addToCartBtn.show();
      $oneClickCheckoutBtn.hide();
      $form.addClass(productFormShowClass);
      $modalBackDrop.show();
      $modalBtn.show();
    });
    $preOneClickCheckoutBtn.click(function () {
      $oneClickCheckoutBtn.show();
      $addToCartBtn.hide();
      $form.addClass(productFormShowClass);
      $modalBackDrop.show();
      $modalBtn.show();
    });

    $modalBackDrop.click(function () {
      $form.removeClass(productFormShowClass);
      $modalBackDrop.hide();
      $preAddToCartBtn.show();
    });

    $modalBtn.click(function () {
      $form.removeClass(productFormShowClass);
      $preAddToCartBtn.show();
      $modalBackDrop.hide();
    });
  }

  function handleOneClickCheckout() {
    function getFormDataMap($form) {
      const formDataArray = $form.serializeArray();
      const formDataMap = {};

      formDataArray.map((item) => {
        formDataMap[item['name']] = item['value'];
      });
      return formDataMap;
    }

    function initLoading() {
      oneClickCheckoutButton.classList.add('disabled');
      oneClickCheckoutButton.innerHTML =
        '<div class="spinner spinner--circle"></div>';
    }

    function stopLoading() {
      oneClickCheckoutButton.classList.remove('disabled');
      oneClickCheckoutButton.innerHTML =
        window.languages.oneClickCheckoutButton;
    }

    const oneClickCheckoutButton = document.querySelector(
      '.product__one-click-checkout',
    );
    if (!oneClickCheckoutButton) {
      return;
    }

    oneClickCheckoutButton.addEventListener('click', async () => {
      initLoading();
      const $form = $('.product__form');
      const formDataMap = getFormDataMap($form);
      const variantId = Number(formDataMap.id);
      const quantity = Number(formDataMap.quantity);
      const selectedVariant = $(`[value="${variantId}"]`);
      const inventoryQuantity = selectedVariant.data('inventory-quantity');
      const productTitle = $('.product .product-meta__title').text();
      const variantTitle =
        selectedVariant.text() && ` - ${selectedVariant.text()}`;

      if (inventoryQuantity < quantity) {
        alert(
          `您只能將 ${inventoryQuantity} 個${productTitle}${variantTitle}新增到購物車。`,
        );
        stopLoading();
        return;
      }

      const event = new CustomEvent('showShippingInfoModal', {
        detail: {
          variantId,
          quantity,
        },
      });
      window.dispatchEvent(event);
      stopLoading();
    });
  }

  function handleProductSlideshow() {
    const targetClass = '.product__slideshow';
    Citiesocial.productManager.initProductSlideshow($(targetClass));
    $(document).on('shopify:section:unload', function (event) {
      const $target = $(event.target);

      $target.find(targetClass).slick('unslick');
      $target.find('.product__slideshow-nav-image').off('click');
      $(document).off(targetClass);
    });

    $(document).on('shopify:section:load', function (event) {
      Citiesocial.productManager.initProductSlideshow(
        $(event.target).find(targetClass),
      );
    });
  }

  function handleProductIntroVideoSize() {
    const $productIntro = $('#cs_product_introduction');
    if ($productIntro.length) {
      $productIntro.fitVids();
    }
  }
});
